/**
 * The WorkOS event names Brew supports, without their metadata, so a
 * client surface that only needs the names or the count (the setup copy in
 * `lib/integrations/catalog/data_in.ts`) does not bundle the whole
 * catalogue. `supported-events.ts` re-exports both.
 */
export type SupportedWorkOSEventType =
  | 'user.created'
  | 'user.updated'
  | 'user.deleted'
  | 'authentication.email_verification_succeeded'
  | 'authentication.password_failed'
  | 'password_reset.succeeded'
  | 'authentication.magic_auth_succeeded'
  | 'organization.created'
  | 'organization.updated'
  | 'organization.deleted'
  | 'organization_membership.created'
  | 'organization_membership.updated'
  | 'organization_membership.deleted'
  | 'dsync.user.created'
  | 'dsync.user.updated'
  | 'dsync.user.deleted'
  | 'connection.activated'
  | 'invitation.accepted'

export const SUPPORTED_WORKOS_EVENTS: ReadonlyArray<SupportedWorkOSEventType> =
  [
    'user.created',
    'user.updated',
    'user.deleted',
    'authentication.email_verification_succeeded',
    'authentication.password_failed',
    'password_reset.succeeded',
    'authentication.magic_auth_succeeded',
    'organization.created',
    'organization.updated',
    'organization.deleted',
    'organization_membership.created',
    'organization_membership.updated',
    'organization_membership.deleted',
    'dsync.user.created',
    'dsync.user.updated',
    'dsync.user.deleted',
    'connection.activated',
    'invitation.accepted',
  ] as const
